export default __webpack_public_path__ + "static/SR USA - BRC Certificado - Seguridad Alimentaria (en inglés)-62db5bea59621756e808c1b02a2f668b.pdf";